(function() {
    const dropdown = document.querySelector(".lawyers-categories select");

    if (dropdown) {
        dropdown.addEventListener("change", function () {
            this.form.submit();
        });
    }
})();
